import React from "react";
import "./blog.css";

const Blog: React.FC = () => {
  return (
    <div className="blog-container">
      <h2>Our Blog</h2>
      <p>
        Explore insights, updates, and expert articles on our official blog.
        Click the link below to read more:
      </p>
      <a
        href="https://transform365.home.blog/"
        target="_blank"
        rel="noopener noreferrer"
        className="blog-link"
      >
        Visit our blog →
      </a>
    </div>
  );
};

export default Blog;
